export enum LocaleListEnum {
  ua = "ua",
  en = "en",
}
